import request from '@/tool/request'

// 首页消息审批热点数量
//   GET /admin-api/bpm/task/getNumberOfHotSpots
//   接口ID：219979543
//   接口地址：https://app.apifox.com/link/project/1068147/apis/api-219979543
export function getNumberOfHotSpots(params) {
  return request({
    url: '/bpm/task/getNumberOfHotSpots',
    method: 'get',
    params
  })
}

// 无密码登录
//   POST /admin-api/system/auth/loginNoPassword
//   接口ID：245912950
//   接口地址：https://app.apifox.com/link/project/1068147/apis/api-245912950
export const loginNoPassword = (params) => {
  return request({
    url: '/system/auth/loginNoPassword',
    method: 'get',
    params
  })
}
